import React, { Fragment, useMemo, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { makeStyles } from "@mui/styles";
import CommonTable from "../../common/commonTable";
import {
  totalProvisionAmtByRegionTableListBodyMainView,
  totalProvisionAmtByRegionTableListHeaderMainView,
  totalProvisionAmtByStateTableListBodyMainView,
  totalProvisionAmtByStateTableListHeaderMainView,
} from "../../common/commonConstant";
import { useEffect } from "react";
import {
  getAgeingProvisionHistoryReportDetailsByRegion,
  getAgeingProvisionHistoryReportDetailsByState,
} from "../../api/service";
import { Line } from "react-chartjs-2";
import { formatMoney } from "../../../constants/utils";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { OutlinedInput } from "@mui/material";
import CommonLoader from "../../common/commonLoader";
import AgeingReportProvisionHistoryModal from "./ageingReportProvisionHistoryModal";
import CommonTableWithFooterFixed from "../../common/commonTableWithFooterFixed";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },
}));

const AgeingReportHistoryProvisionSection = (props) => {
  const {
    searchData,
    totalProvisionAmountByRegionByMonthList,
    totalProvisionAmountByStateByMonthList,
  } = props;

  const classes = useStyles();
  const [
    totalProvisionAmountByRegionTableListData,
    setTotalProvisionAmountByRegionTableListData,
  ] = useState([]);

  const [
    totalProvisionAmountByStateTableListData,
    setTotalProvisionAmountByStateTableListData,
  ] = useState([]);

  const [modalData, setModalData] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [isRegion, setIsRegion] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeProvTab, setActiveProvTab] = useState("prov1");

  const handleProvTabChange = (event, newValue) => {
    setActiveProvTab(newValue);
  };

  // Function to assign colors dynamically
  const getColor = (region) => {
    const colorMap = {
      West: "#0e87d7",
      North: "#b255ec",
      East: "#a6b90e",
      South: "#d7600e",
    };
    return colorMap[region];
  };

  // 27 unique background colors
  const backgroundColors = [
    "#1a139f",
    "#ff6384",
    "#36a2eb", //Bihar
    "#ffce56",
    "#4bc0c0",
    "#9966ff",
    "#ff9f40",
    "#e74c3c",
    "#2ecc71",
    "#f39c12",
    "#9b59b6",
    "#8e44ad",
    "#2c3e50",
    "#d35400",
    "#16a085",
    "#c0392b",
    "#7f8c8d",
    "#e67e22",
    "#2980b9",
    "#f1c40f",
    "#27ae60",
    "#34495e",
    "#dc7633",
    "#f1948a",
    "#84697d", //#5dade2 UP
    "#58d68d",
    "#9fb6a0",
  ];

  // BY STATE STARTS

  const [selectedProvisionStateName, setSelectedProvisionStateName] = useState([
    "Bihar",
    "Uttar Pradesh",
  ]);

  const lineChartByFinancialYearOptionRegion = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true, // Enables circular legend icons
          boxWidth: 10, // Adjusts size
          color: "#000",
        },
      },
    },
    scales: {
      xAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
      yAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
    },
  };

  const lineChartByFinancialYearOptionState = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true, // Enables circular legend icons
          boxWidth: 10, // Adjusts size
          color: "#000",
        },
      },
    },
    scales: {
      xAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
      yAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
    },
  };

  const [openProvisionModal, setOpenProvisionModal] = useState(false);

  const handleProvisionChange = (event) => {
    const {
      target: { value },
    } = event;
    /* setSelectedProvisionStateName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    ); */
    const isString = typeof value === "string";
    const selected = isString ? value.split(",") : value;
    const allStatesExceptSelectAll = provisionStateList.filter(
      (s) => s !== "Select All"
    );

    // Case 1: User just unchecked "Select All"
    const isUncheckingSelectAll =
      selected.includes("Select All") === false &&
      selected.length < selectedProvisionStateName.length &&
      selectedProvisionStateName.includes("Select All");

    if (isUncheckingSelectAll) {
      setSelectedProvisionStateName([]);
      return;
    }

    // Case 2: User checked "Select All"
    if (selected.includes("Select All")) {
      setSelectedProvisionStateName(provisionStateList); // select all
      return;
    }

    // Case 3: User manually selected all states except "Select All"
    const filtered = selected.filter((s) => s !== "Select All");
    if (
      filtered.length === allStatesExceptSelectAll.length &&
      !selected.includes("Select All")
    ) {
      setSelectedProvisionStateName(provisionStateList); // auto-add "Select All"
    } else {
      setSelectedProvisionStateName(filtered); // normal case
    }
  };

  //PROVISON AMOUNT REGION DETAILS
  const processProvisionAmountChartDataForRegion = (data) => {
    // Extract unique months (x-axis labels)
    const months = [...new Set(data.map((item) => item.monthName))];
    // Extract unique regions
    const regions = [...new Set(data.map((item) => item.regionName))];

    // Create datasets for each region
    const datasets = regions.map((region) => ({
      label: region,
      backgroundColor: "transparent",
      borderColor: getColor(region),
      pointBackgroundColor: getColor(region),
      data: months.map((month) => {
        const entry = data.find(
          (item) => item.monthName === month && item.regionName === region
        );
        return entry ? entry.totalProvisionAmount : 0; // Default to 0 if missing
      }),
      lineTension: 0.4,
    }));

    // Calculate total across all regions for each month
    const totalDataset = {
      label: "Total",
      backgroundColor: "transparent",
      borderColor: "#333333",
      pointBackgroundColor: "#333333",
      data: months.map((month) => {
        return data
          .filter((item) => item.monthName === month)
          .reduce((sum, item) => sum + (item.totalProvisionAmount || 0), 0);
      }),
      lineTension: 0.4,
    };

    return {
      labels: months,
      datasets,
      datasetsForList: [...datasets, totalDataset],
    };
  };

  const lineChartForProvisionAmountRegionData =
    processProvisionAmountChartDataForRegion(
      totalProvisionAmountByRegionByMonthList
    );

  useEffect(() => {
    if (
      lineChartForProvisionAmountRegionData?.datasets &&
      lineChartForProvisionAmountRegionData?.datasets.length > 0
    ) {
      const transformedData =
        lineChartForProvisionAmountRegionData?.datasetsForList.map((item) => {
          return {
            regionName: item.label,
            junMonthVal: formatMoney(item.data[0]),
            sepMonthVal: formatMoney(item.data[1]),
            decMonthVal: formatMoney(item.data[2]),
            marMonthVal: formatMoney(item.data[3]),
            liveMonthVal: formatMoney(item.data[4]),
          };
        });

      setTotalProvisionAmountByRegionTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(transformedData)
          ? transformedData
          : prevData
      );
    }
  }, [lineChartForProvisionAmountRegionData]);

  const onOpenProvisionModalRegion = (row) => {
    const filteredItem = totalProvisionAmountByRegionByMonthList.find(
      (item) => item.regionName === row.regionName
    );
    const regionMasterId = filteredItem.regionMasterId;
    setIsRegion(true);
    if (regionMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingProvisionHistoryReportDetailsByRegion(
        regionMasterId,
        divisionId,
        asmLoginId
      ).then((res) => {
        setLoading(false);
        setModalData(
          res.response.responseMap.ageingReportsWithDivisionByRegion
        );
        //setOpen
        setRowData(row);
        setOpenProvisionModal(true);
      });
    }
  };
  //PROVISON AMOUNT REGION DETAILS

  //PROVISON AMOUNT STATE DETAILS

  /* const [provisionStateList, setProvisionStateList] = useState([
    ...new Set(
      totalProvisionAmountByStateByMonthList.map((item) => item.stateName)
    ),
  ]); */
  const provisionStateList = useMemo(() => {
    const uniqueStates = [
      ...new Set(
        totalProvisionAmountByStateByMonthList.map((item) => item.stateName)
      ),
    ];

    return ["Select All", ...uniqueStates];
    /* return [
      ...new Set(
        totalProvisionAmountByStateByMonthList.map((item) => item.stateName)
      ),
    ]; */
  }, [totalProvisionAmountByStateByMonthList]);

  const processProvisionChartDataForState = (data) => {
    // Extract unique months (x-axis labels)
    const months = [...new Set(data.map((item) => item.monthName))];

    // Extract unique regions
    const states = [...new Set(data.map((item) => item.stateName))];

    // Create datasets for each region
    const datasets = states.map((state, index) => ({
      label: state,
      backgroundColor: "transparent",
      borderColor: backgroundColors[index],
      pointBackgroundColor: backgroundColors[index],
      data: months.map((month) => {
        const entry = data.find(
          (item) => item.monthName === month && item.stateName === state
        );
        return entry ? entry.totalProvisionAmount : 0; // Default to 0 if missing
      }),
      lineTension: 0.4,
    }));
    return { labels: months, datasets };
  };

  const lineChartForProvisionAmountStateData =
    processProvisionChartDataForState(totalProvisionAmountByStateByMonthList);

  const filteredDatasetsProvisionState =
    lineChartForProvisionAmountStateData.datasets.filter((dataset) =>
      selectedProvisionStateName.includes(dataset.label)
    );

  /* const lineChartByFinancialYearDataProvisionStateFiltered = {
    ...lineChartForProvisionAmountStateData,
    datasets: filteredDatasetsProvisionState,
  };
 */
  const lineChartByFinancialYearDataProvisionStateFiltered = useMemo(() => {
    return {
      ...lineChartForProvisionAmountStateData,
      datasets: filteredDatasetsProvisionState,
    };
  }, [lineChartForProvisionAmountStateData, filteredDatasetsProvisionState]);

  const getTotalValueForState = (processedChartData, index) => {
    return formatMoney(
      processedChartData.datasets.reduce(
        (sum, item) => sum + (item.data[index] || 0),
        0
      )
    );
  };

  useEffect(() => {
    if (
      lineChartForProvisionAmountStateData?.datasets &&
      lineChartForProvisionAmountStateData?.datasets.length > 0
    ) {
      /* const processedChartData =
        selectedProvisionStateName.length > 0
          ? lineChartByFinancialYearDataProvisionStateFiltered
          : lineChartForProvisionAmountStateData; */
      const processedChartData = lineChartForProvisionAmountStateData;

      const transformedData = processedChartData?.datasets.map((item) => {
        return {
          stateName: item.label,
          junMonthVal: formatMoney(item.data[0]),
          sepMonthVal: formatMoney(item.data[1]),
          decMonthVal: formatMoney(item.data[2]),
          marMonthVal: formatMoney(item.data[3]),
          liveMonthVal: formatMoney(item.data[4]),
        };
      });

      /* setTotalProvisionAmountByStateTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(transformedData)
          ? transformedData
          : prevData
      ); */
      const totalRow = {
        stateName: "Total",
        junMonthVal: getTotalValueForState(processedChartData, 0),
        sepMonthVal: getTotalValueForState(processedChartData, 1),
        decMonthVal: getTotalValueForState(processedChartData, 2),
        marMonthVal: getTotalValueForState(processedChartData, 3),
        liveMonthVal: getTotalValueForState(processedChartData, 4),
      };

      const finalData = [...transformedData, totalRow];

      setTotalProvisionAmountByStateTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(finalData)
          ? finalData
          : prevData
      );
    }
  }, [
    lineChartForProvisionAmountStateData,
    selectedProvisionStateName,
    lineChartByFinancialYearDataProvisionStateFiltered,
  ]);

  const onOpenProvisionModalState = (row) => {
    const filteredItem = totalProvisionAmountByStateByMonthList.find(
      (item) => item.stateName === row.stateName
    );
    const stateMasterId = filteredItem.stateMasterId;
    setIsRegion(false);
    if (stateMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingProvisionHistoryReportDetailsByState(
        stateMasterId,
        divisionId,
        asmLoginId
      ).then((res) => {
        setLoading(false);
        setRowData(row);
        setModalData(res.response.responseMap.ageingReportsWithDivisionByState);
        //setOpen
        setOpenProvisionModal(true);
      });
    }
  };
  //PROVISON AMOUNT STATE DETAILS
  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <TabContext value={activeProvTab}>
            <TabList
              onChange={handleProvTabChange}
              aria-label="lab API tabs example"
              indicatorColor="secondary"
              textColor="secondary"
              style={{ background: "white" }}
            >
              <Tab label="By Region" value="prov1" />
              <Tab label="By State" value="prov2" />
            </TabList>
            {/* By Region Section Starts*/}
            <TabPanel value="prov1">
              <Card>
                {/* <CardHeader
                  style={{
                    padding: "10px 10px 0px",
                  }}
                >
                  <h5>By Region</h5>
                </CardHeader> */}
                <CardBody className={classes.cardbody}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <h5>Trend for L12M</h5>
                        <CardBody className="sell-graph">
                          <Line
                            data={lineChartForProvisionAmountRegionData}
                            options={lineChartByFinancialYearOptionRegion}
                            width={700}
                            height={350}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="12">
                      <Card>
                        <CardBody className="sell-graph">
                          <CommonTableWithFooterFixed
                            tableData={totalProvisionAmountByRegionTableListData.filter(
                              ({ regionName }) =>
                                regionName?.toLowerCase() !== "total"
                            )}
                            tableHeaders={
                              totalProvisionAmtByRegionTableListHeaderMainView
                            }
                            tableColumns={
                              totalProvisionAmtByRegionTableListBodyMainView
                            }
                            editId={"regionMasterId"}
                            editMode={true}
                            onOpenModal={onOpenProvisionModalRegion}
                            rowsPerPageOptions={[25, 50, 100]}
                            count={
                              totalProvisionAmountByRegionTableListData.length
                            }
                            rowsPerPage={25}
                            page={0}
                            displayPagination={false}
                            tableFooterData={totalProvisionAmountByRegionTableListData.filter(
                              ({ regionName }) =>
                                regionName?.toLowerCase() === "total"
                            )}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </TabPanel>
            {/* By Region Section Ends*/}
            {/* By State Section Starts*/}
            <TabPanel value="prov2">
              <Row>
                <Col sm="12">
                  <div>
                    <FormControl sx={{ mt: 1, mb: 2, width: 600 }}>
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        sx={{ top: -8 }}
                      >
                        Select State
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={selectedProvisionStateName}
                        onChange={handleProvisionChange}
                        input={<OutlinedInput label="Select State" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                      >
                        {provisionStateList.map((name) => (
                          <MenuItem key={name} value={name}>
                            <Checkbox
                              checked={selectedProvisionStateName.includes(
                                name
                              )}
                            />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {selectedProvisionStateName.length > 0 && (
                    <Card>
                      <h5>Trend for L12M</h5>
                      <CardBody className="sell-graph">
                        <Line
                          data={
                            lineChartByFinancialYearDataProvisionStateFiltered
                          }
                          options={lineChartByFinancialYearOptionState}
                          width={700}
                          height={350}
                        />
                      </CardBody>
                    </Card>
                  )}
                </Col>
                <Col sm="12">
                  <Card>
                    <CardBody className="sell-graph">
                      {/*  <Box display={"flex"}>
                            <Button
                              style={{
                                marginLeft: 10,
                                marginBottom: 4,
                                width: 250,
                              }}
                              color="dark"
                              variant="contained"
                              type="button"
                              onClick={() =>
                                setShowDetailedViewState(!showDetailedViewState)
                              }
                            >
                              {`View ${
                                !showDetailedViewState ? "Detailed" : "Main"
                              } data`}
                            </Button>
                          </Box> */}
                      <CommonTableWithFooterFixed
                        tableData={totalProvisionAmountByStateTableListData.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() !== "total"
                        )}
                        tableHeaders={
                          totalProvisionAmtByStateTableListHeaderMainView
                        }
                        tableColumns={
                          totalProvisionAmtByStateTableListBodyMainView
                        }
                        editId={"stateMasterId"}
                        editMode={true}
                        onOpenModal={onOpenProvisionModalState}
                        rowsPerPageOptions={[25, 50, 100]}
                        count={totalProvisionAmountByStateTableListData.length}
                        rowsPerPage={25}
                        page={0}
                        displayPagination={false}
                        tableFooterData={totalProvisionAmountByStateTableListData.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() === "total"
                        )}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPanel>
            {/* By State Section Ends*/}
          </TabContext>
        </Row>

        <AgeingReportProvisionHistoryModal
          open={openProvisionModal}
          onCancel={() => {
            setOpenProvisionModal(false);
            setRowData(null);
            setModalData([]);
            setIsRegion(false);
          }}
          modalData={modalData}
          title={`${
            rowData && (isRegion ? rowData?.regionName : rowData?.stateName)
          } - Ageing Report Provision History`}
        />
      </Container>
      {/* <!-- Container-fluid Ends--> */}
    </Fragment>
  );
};

export default AgeingReportHistoryProvisionSection;
